export const clientApplicationProjectType: { [key: string]: string } = {
  TWO_UNIT: "2 Unit",
  DUPLEX: "Duplex",
  MAINTENANCE_FACILITY: "Maintenance Facility",
  MIXED_USE: "Mixed-Use",
  OFFICE: "Office",
  RECREATION_CENTER: "Recreation Center",
  RETAIL_MEDICAL: "Retail - Medical",
  RETAIL_OFFICE: "Retail - Office",
  RETAIL_RESTAURANT: "Retail - Restaurant",
  RETAIL_TRADITIONAL: "Retail - Traditional",
  SMALL_MULTI_FAMILY: "Small Multi-Family",
  SCHOOL: "School",
  SINGLE_FAMILY: "Single Family",
};

export const clientApplicationConstructionType: { [key: string]: string } = {
  GUT_REHABILITATION: "Gut Rehabilitation",
  HISTORIC_RENOVATION: "Historic Renovation",
  INTERIOR_FITOUT: "Interior Fitout",
  NEW_CONSTRUCTION: "New Construction",
  RENOVATION: "Renovation",
};

export const clientApplicationProjectStatus: { [key: string]: string } = {
  SOLD: "Sold",
  LEASED: "Leased",
  OWNER_USE: "Owner Use",
};
